import { TilesType } from 'types/src/types';
import { Icon } from './Icon';
import { TooltipComponent } from '../layout';

type Props = {
  onClick: (type: TilesType) => void;
};

export const AddTitleIcon = ({ onClick }: Props) => {
  return (
    <TooltipComponent
      text="Section Title"
      className="bg-black text-white w-fit"
    >
      <button
        className="border-1 border-black/5 bg-white rounded-[8px] overflow-hidden size-8 custom-shadow hover:bg-bg-gray transition-all ease-in-out duration-300 flex items-center justify-center"
        onClick={() => onClick('add-title')}
      >
        <Icon
          name="title"
          width={17}
          height={13}
          className="bg-transparent text-black"
        />
      </button>
    </TooltipComponent>
  );
};
